import React, { forwardRef } from 'react'

import styles from './style.module.css'

type Props = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  label: React.ReactNode
}

export const CheckBoxLabel = forwardRef<HTMLInputElement, Props>(
  ({ label, ...inputProps }, ref) => (
    <label className={styles.label}>
      <input ref={ref} type="checkbox" {...inputProps} />
      <span>{label}</span>
    </label>
  )
)

CheckBoxLabel.displayName = 'CheckBoxLabel'
